import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoadingSquareCard from '../LoadingSquareCard';

const StrainCard = ({
  strainID,
  strainName,
  strainImage,
  justViewed,
  cookie,
  strainType,
  newStrain
}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
  }, [strainType]);
  return (
    <div className="strain">
      <Link
        onClick={() => {
          cookie.set('just_viewed', strainID);
        }}
        to={`/strains/${strainID}`}>
        <div className={`strain-image strain-image-container`}>
          {loading && <LoadingSquareCard />}
          <img
            src={strainImage}
            alt={'Cresco Cannabis' + strainName}
            style={loading ? { display: 'none' } : { display: 'block' }}
            onLoad={() => {
              setLoading(false);
            }}
          />
          {newStrain && (
            <p className="new-strain new-strain-finder">
              <span>new new new new new new new</span>
            </p>
          )}
          {/* {justViewed === strainID && (
            <p className="just-viewed just-viewed-text">
              <span>just viewed</span>
            </p>
          )} */}
        </div>
        <h6>{strainName}</h6>
      </Link>
    </div>
  );
};

export default StrainCard;
